import '../scss/styles.scss';

const App = require('./app/main');

$(document).ready(() => {
    App.start();
});
